<div class="user-menu" #userProfileWrapper>
  <button
    type="button"
    class="user-btn profile-pill"
    [class.profile-pill--plain]="!(clientLogo && !logoHasError)"
    (click)="toggleDropdown()"
  >
    <app-avatar
      role="employee"
      [profileImageUrl]="userProfile"
      [firstName]="avatarFirstName"
      [lastName]="avatarLastName"
      size="xs"
      class="profile-pill-avatar"
    >
    </app-avatar>

    @if (clientLogo && !logoHasError) {
      <img
        [src]="clientLogo"
        alt="Company Logo"
        class="profile-pill-logo"
        (error)="onLogoError()"
      />
    }
  </button>

  @if (isDropdownOpen) {
    <ul class="dropdown-menu">
      @if (showChangePassword) {
        <li>
          <a (click)="onChangePasswordClick()" class="nav-link-sm">
            <i class="hgi hgi-stroke hgi-rounded hgi-key-01"></i> Change Password
          </a>
        </li>
      }
      <li>
        <a (click)="logout()" class="nav-link-sm">
          <i class="hgi hgi-stroke hgi-rounded hgi-logout-01"></i> Logout
        </a>
      </li>
    </ul>
  }
</div>
